import React from 'react';

import { defineMessages, useIntl } from 'react-intl';
import { graphql, useFragment } from 'react-relay';

import { Text } from '@atlaskit/primitives/compiled';

import type { UpdateWorkItemAllFieldTypesAction } from '../../../../../common/types';
import { getActionData } from '../../../utils';

import type { flagField_updateWorkItemAllFieldTypesActionRenderer$key } from './__generated__/flagField_updateWorkItemAllFieldTypesActionRenderer.graphql';
import { isFlagged } from './utils';

const messages = defineMessages({
	flagged: {
		id: 'update-work-item-all-fields-action-renderer.ui.action-card.flag-field.flagged',
		defaultMessage: 'Add flag',
		description: 'Label for the change action in the flag field',
	},
	unflagged: {
		id: 'update-work-item-all-fields-action-renderer.ui.action-card.flag-field.unflagged',
		defaultMessage: 'Remove flag',
		description: 'Label for the change action in the flag field',
	},
});

export type Props = {
	queryRef: flagField_updateWorkItemAllFieldTypesActionRenderer$key;
	action: UpdateWorkItemAllFieldTypesAction;
};

export const FlagField = ({ queryRef, action }: Props): React.JSX.Element | null => {
	const { formatMessage } = useIntl();

	const { fieldKey, fieldValue } = getActionData(action);

	const data = useFragment(
		graphql`
			fragment flagField_updateWorkItemAllFieldTypesActionRenderer on JiraFlagField {
				fieldId
			}
		`,
		queryRef,
	);

	if (!data?.fieldId || data?.fieldId !== fieldKey) {
		return null;
	}

	const flagged = isFlagged(fieldValue);

	return (
		<Text
			color="color.text.subtle"
			maxLines={1}
			testId="update-work-item-all-fields-action-renderer.ui.action-card.card-fields-list.flag-field"
		>
			{flagged ? formatMessage(messages.flagged) : formatMessage(messages.unflagged)}
		</Text>
	);
};
